<!-- Revised on 2024/11/24 by mnavarro -->
<template>
  <div v-if="enableSearch" class="input-group ms-2">
    <span class="input-group-text text-body">
      <i class="fas fa-search" aria-hidden="true"></i>
    </span>
    <input v-model="searchValue" class="form-control" :placeholder="$t('key_text_search')" :text="searchValue" type="text" @input="changeInput($event)" />
    <span v-if="searchValue" class="input-group-text text-body" @click="clearSearch">
      <i class="fas fa-xmark" aria-hidden="true" ></i>
    </span>
  </div>
</template>

<script>

  export default {
    name: "Searchbox",
    props: {
      enableSearch: {
        type: Boolean,
        default: true,
      },
      listFilters: {
        type: Object,
        default: null,
      },
    },
    emits: ['change'],
    data() {
      return {
        searchValue: ''
      }
    },
    watch: {
      listFilters(){
        if (this.listFilters['filters']['search']) {
          this.searchValue = this.listFilters['filters']['search']
        }
      }
    },
    methods: { 
      changeInput(val) {
        this.$emit('change', val.target.value);
      },
      clearSearch() {
        this.searchValue = '';
        this.$emit('change', this.searchValue);
      }
    }
  };

</script>